import { useI18n, getContent } from '../i18n';
import HonorsIntro from './HonorsIntro';
import { Link, buildPath, type ModeKey } from '../router';
import type { Lang } from '../lib/countries';

const MODES: ModeKey[] = ['classic', 'flag', 'outline', 'connections', 'draw', 'trivia'];
/** Trivia 没有无尽模式,别在 Unlimited 那行给它出死链 */
const ENDLESS_MODES: ModeKey[] = MODES.filter((m) => m !== 'trivia');

// 可见 SEO 内容区:每个子模式有自己的 About / How to play;Modes(带内链)/ FAQ 共用 —— §5.3
export default function SeoContent({ lang, mode = 'classic', honors = false }: { lang: Lang; mode?: ModeKey; honors?: boolean }) {
  const { t } = useI18n();
  const c = getContent(lang).content;
  const seo = c.seo?.[mode] ?? { aboutTitle: c.aboutTitle, about: c.about, howTo: c.howTo, faq: c.faq };

  return (
    <section className="seo-content">
      <h2>{seo.aboutTitle}</h2>
      <p>{seo.about}</p>

      <h2>{c.howToTitle}</h2>
      <ol>
        {seo.howTo.map((s, i) => (
          <li key={i}>{s}</li>
        ))}
      </ol>

      {/* Game Modes 只在首页出现 —— 子模式页顶部就有模式导航,再列一遍是重复内容;
          换成该模式自己的攻略,每页不同,对 SEO 也更有价值 */}
      {mode === 'classic' ? (
        <>
          <h2>{c.modesTitle}</h2>
          <p>{c.modesIntro}</p>
          <ul className="seo-modes">
            {MODES.map((mk) => (
              <li key={mk}>
                <Link to={buildPath(lang, mk)}>{t.modes[mk]}</Link> — {c.modes[mk]}
              </li>
            ))}
          </ul>
          <p className="seo-unlimited">
            {getContent(lang).unlimited.desc}{' '}
            {ENDLESS_MODES.map((mk, i) => (
              <span key={mk}>
                {i > 0 && ' · '}
                <Link to={buildPath(lang, mk, true)}>
                  {t.modes[mk]} {t.unlimited}
                </Link>
              </span>
            ))}
          </p>
        </>
      ) : (
        seo.tips && (
          <>
            <h2>{c.tipsTitle}</h2>
            <ul className="seo-tips">
              {seo.tips.map((x, i) => (
                <li key={i}>{x}</li>
              ))}
            </ul>
          </>
        )
      )}

      {/* 首页专属:三种徽记的说明,排在模式介绍之后、FAQ 之前 */}
      {honors && <HonorsIntro />}

      <h2>{c.faqTitle}</h2>
      <dl className="seo-faq">
        {seo.faq.map((f, i) => (
          <div key={i}>
            <dt>{f.q}</dt>
            <dd>{f.a}</dd>
          </div>
        ))}
      </dl>
    </section>
  );
}
